<template>
  <ViewRecordingModal />
  <div class="card mb-25 border-0 radius-7 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <div class="container-title-date mb-40">
        <h5 class="ml-5 text-center text-sm-center text-md-center text-lg-start text-xl-start text-xxl-start">Selecione o filtro</h5> 
  
        <div class="area-search-recording row p-10 flex-column flex-column-row flex-sm-row flex-lg-row flex-xl-row flex-xxl-row flex-xxxl-row">

          <input
            class="input-date-range flatpickr form-control fs-md-15 text-black shadow-none mb-10 col-12 col-sm-12"
            type="text"
            placeholder="Selecione a data"
            id="basicCalendar"
            ref="datePickr"
          />

          <input
            class="input-date-range flatpickr form-control fs-md-15 text-black shadow-none mb-10 ms-sm-10 ms-lg-10 ms-xl-10 ms-xxl-10 ms-xxxl-10 col-12 col-sm-12"
            type="text"
            placeholder="Nome do arquivo"
            id="nameRecordField"
            ref="nameRecord"
          />

          <input
            class="input-date-range flatpickr form-control fs-md-15 text-black shadow-none mb-10 ms-sm-10 ms-lg-10 ms-xl-10 ms-xxl-10 ms-xxxl-10 col-12 col-sm-12"
            type="text"
            placeholder="Transcrição"
            id="transcriptRecordField"
            ref="transcriptRecord"
          />

          <select id="analyze" class="input-date-range form-select shadow-none text-black fs-md-15 mb-10 ms-sm-10 ms-lg-10 ms-xl-10 ms-xxl-10 ms-xxxl-10 col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <option selected value="">Sentimento (Todos)</option>
            <option value="negativo">Negativo</option>
            <option value="neutro">Neutro</option>
            <option value="positivo">Positivo</option>
          </select>

          <select id="index_origin" class="input-date-range form-select shadow-none text-black fs-md-15 mb-10 ms-sm-10 ms-lg-10 ms-xl-10 ms-xxl-10 ms-xxxl-10 col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <option selected value="null">Todas as origens</option>
            <option v-for="(value, key) in getIndexRecordSearch" :key="key" :value="value">{{ value }}</option>
          </select>

          <button id="buttonSearchRecordingsApi" type="button" class="btn btn-success mb-10 ms-sm-10 ms-lg-10 ms-xl-10 ms-xxl-10 ms-xxxl-10 col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 col-xxl-2 col-xxxl-2" @click="searchRecordings()">Pesquisar</button>
        </div>

      </div>

    
      


      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Data
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nome original
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nome de conversão
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Possui transcrição
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Análise de sentimento
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Duração
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Ouvir
              </th>
            </tr>
          </thead>

          <tbody>
            <tr 
              v-for="(value, key) in getRecordingsPagination[currentPage]"
              :key="key"
            >
              <th
                class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
              >
                <div
                  class="d-flex align-items-center fs-md-15 fs-lg-16 fw-medium"
                >
                  {{ value.created_at }} 
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.original_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-if="value.file_name != null && value.file_name != '' && value.original_name != null && value.original_name != ''">
                  {{ value.file_name }}
                </span>
                <span v-else class="badge text-bg-danger fs-13 radius-7">Arquivo corrompido</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.transcribed == 1 ? "Sim" : "Não" }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.analyzed ? value.sentiment : "Não" }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.duration}}
              </td>
              <td class="pb-20 pt-0 shadow-none lh-1 fw-medium text-black-emphasis">
                <div class="card mb-25 border-0 rounded-0 bg-white recent-activity-box" @click="setRecordingOnModal(value)" data-bs-toggle="modal" data-bs-target="#ViewRecordingModal">
                    <ul class="list ps-0 mb-0 list-unstyled">                      
                      <li class="position-relative fw-medium text-dark-emphasis">
                        <div class="icon position-absolute start-0 rounded-circle text-center pointer">
                          <i class="flaticon-headphones"></i>
                        </div>
                      </li>
                    </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <p class="mb-0 text-paragraph">
          <span class="fw-bold">{{ getRecordings.length }}</span> resultados
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li class="pointer page-item">
              <a class="page-link" @click="backPage()" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li 
              v-for="(value, key) in getRecordingsPagination"
              :key="key"
              class="pointer page-item"
            >
              <a class="page-link z" :class="{active: key == currentPage}" @click="changePage(key)">{{ key + 1}}</a>
            </li>
            <li class="pointer page-item">
              <a class="page-link" @click="nextPage()" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import moment from 'moment';
import ViewRecordingModal from './ViewRecordingModal.vue';

export default defineComponent({
  name: "RecentFiles",
  data () {
    return {
      currentPage: 0
    }
  },
  components: {
    ViewRecordingModal
  },
  computed: {
    ...mapGetters([
      'getRecordings',
      'getRecordingsPagination',
      'getIndexRecordSearch'
    ])
  },
  mounted(){
    flatpickr("#basicCalendar", {
      mode: "range",
      locale: Portuguese,
      //dateFormat: "Y-m-d"
      dateFormat: "d/m/Y"
    });
    
    this.setIndexRecordSearch();
    this.searchRecordings();
  },
  methods: {
    ...mapActions([
        "setRecordings",
        "setCurrentRecording",
        "setRecordingShowModalState",
        "setIndexRecordSearch"
    ]),
    setRecordingOnModal(currentRecording){
      this.setRecordingShowModalState(true);
      this.setCurrentRecording(currentRecording);
    },
    changePage(page){
      this.currentPage = page;
    },
    nextPage(){
      if(this.currentPage == this.getRecordingsPagination.length - 1){
        return;
      }
      this.currentPage++
    },
    backPage(){
      if(this.currentPage == 0){
        return;
      }
      this.currentPage--
    },
    searchRecordings(
    ){
        
        const input = document.getElementById("basicCalendar");
        const inputName = document.getElementById("nameRecordField");
        const index_origin = document.getElementById("index_origin");
        const transcriptRecordField = document.getElementById("transcriptRecordField");
        const analyzeField = document.getElementById("analyze");

        if(input.value == ""){
          return;
        }

        let initDate = "";
        let endDate = "";

        if(input.value.includes(" até ")){
          const newDate = input.value.split(" até ");
          initDate = moment(newDate[0], "DD/MM/YYYY").format("YYYY-MM-DD");
          endDate = moment(newDate[1], "DD/MM/YYYY").format("YYYY-MM-DD");
        } else {
          initDate = moment(input.value, "DD/MM/YYYY").format("YYYY-MM-DD");
          endDate = moment(input.value, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
        
        const filter = {
            "dateInit": initDate,
            "dateEnd": endDate,
            "name": inputName.value != "" ? inputName.value : null,
            "index": index_origin.value,
            "transcriptRecordField": transcriptRecordField != null && transcriptRecordField.value.trim() != "" ? transcriptRecordField.value : null,
            "analyzeField": analyzeField != null && analyzeField.value.trim() != "" ? analyzeField.value : null,
        }

        this.currentPage = 0;

        const buttonSearchRecordingsApi = document.getElementById("buttonSearchRecordingsApi");
        buttonSearchRecordingsApi.disabled = true;
        buttonSearchRecordingsApi.innerHTML = "Buscando...";

        this.setRecordings(filter).then(() => {
          buttonSearchRecordingsApi.disabled = false;
          buttonSearchRecordingsApi.innerHTML = "Pesquisar";
        });
    }
  }
});
</script>
<style scoped>
/* ---------------------------------------------------------
   LAYOUT RESPONSIVO SIMPLES (apenas layout)
   - mobile: empilhado (coluna)
   - tablet: duas colunas
   - desktop (>=992px): tudo em uma linha
   NÃO altera cores, bordas ou aparências de inputs/buttons.
   --------------------------------------------------------- */

/* área que contém os filtros */
.area-search-recording {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;            /* controle de espaçamento entre os campos */
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

/* Por padrão (mobile) cada item ocupa 100% (empilha) */
.area-search-recording > * {
  flex: 1 1 100%;
  min-width: 0; /* evita overflow de textos longos */
}

/* Mantém altura mínima agradável e não altera bordas/cores */
.area-search-recording input,
.area-search-recording .form-select,
.area-search-recording button {
  min-height: 44px;
  box-sizing: border-box;
}

.row{
  --bs-gutter-x: unset !important;
}

/* Tablet médio: duas colunas aproximadas */
@media (min-width: 768px) and (max-width: 991px) {
  .area-search-recording > * {
    flex: 1 1 48%; /* duas colunas com gap entre elas */
  }
}

/* Desktop: tudo em uma linha (ajuste por posição seguindo a ordem do template) */
@media (min-width: 992px) {
  .area-search-recording {
    flex-wrap: nowrap;
  }

  /* Ajustes de largura por posição (orde padrão do seu template) */
  .area-search-recording > *:nth-child(1) { flex: 0 0 18%; }  /* data */
  .area-search-recording > *:nth-child(2) { flex: 0 0 18%; }  /* nome do arquivo */
  .area-search-recording > *:nth-child(3) { flex: 0 0 18%; }  /* transcrição */
  .area-search-recording > *:nth-child(4) { flex: 0 0 12%; }  /* analyze select */
  .area-search-recording > *:nth-child(5) { flex: 0 0 12%; }  /* index_origin select */
  .area-search-recording > *:nth-child(6) { flex: 0 0 12%; }  /* botão pesquisar */

  /* garante que o botão ocupe toda a sua coluna */
  .area-search-recording > *:nth-child(6) { display: flex; }
  .area-search-recording > *:nth-child(6) button {
    width: 100%;
    white-space: nowrap;
  }
}

/* ---------------------------------------------------------
   TRUNCAMENTO DO VALOR DO SELECT + ESPAÇO PARA A SETA
   - Aplica ellipsis ao texto visível do select
   - No desktop substitui a seta nativa por um ícone via background
   - NÃO altera cores nem bordas (usa current styling)
   --------------------------------------------------------- */

/* Garante truncamento do valor exibido no select */
.area-search-recording .form-select {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 40px; /* espaço para a seta custom */
  box-sizing: border-box;
}

/* No desktop, substitui a seta nativa por uma pequena SVG (mantém aparência) */
@media (min-width: 992px) {
  .area-search-recording .form-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 10px 6px;
    /* seta simples em SVG que segue a cor do texto via currentColor */
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'><path d='M1 1l4 4 4-4' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>");
    background-color: transparent;
  }

  /* Esconder o expand do IE/Edge se aparecer */
  .area-search-recording .form-select::-ms-expand {
    display: none;
  }
}

/* Pequeno ajuste: remove margens Bootstrap redundantes que causam "dobro espaçamento"
   apenas dentro desta área para manter o gap consistente */
.area-search-recording .mb-10 {
  margin-bottom: 0 !important;
}
</style>
